<template lang="pug">
	div(class="kt-task-board")
		div(class="d-flex my-2")
			div(v-for="(gd,ix) in p_vSwimLn.items" :key="ix" v-if="gd.visible" class="board-list " :class="gd.classNm")
				label() {{gd.name}}
				div(v-show="!d_ktt.d_loading && !d_ktt.d_errMessage")
					draggable(group="group-status" :list="gd.dragList" class="drag-items" animation=150 swapThreshold=1 
						filter=".drag-item-opt"
						@change="m_changeSwimlane($event,gd)" @start="m_onStart" @end="m_onEnd")
						div(v-for="(dlt, ix) in gd.dragList" :key="dlt.id" class="drag-item" 
							:class="dlt.id == d_ktt.d_savedId ? 'kt-saved':null")
							//- Edit/Clone/Delete Option
							span(v-if="dlt.id == d_ktt.d_savedId" class="saved-check mr-1")
								fa-icon(icon="check" class="text-success")
							b-dropdown(class="drag-item-opt" variant="grey1" right lazy=true no-caret=true)
								div(class="dropdown-item" @click="d_ktt.m_editTask(dlt.ref, ix)")
									fa-icon(icon="pencil-alt")
									|  Edit
								div(class="dropdown-item" @click="d_ktt.m_cloneTask(dlt.ref, ix)")
									fa-icon(icon="copy")
									|  Clone
								div(class="dropdown-item" @click="d_ktt.m_deleteTask(dlt.ref, ix)")
									fa-icon(icon="times")
									|   Delete
								template(v-slot:button-content) 
									fa-icon(icon="bars" class="text-primary")
							//- Field Data
							div(v-for="col in p_cols.filter(x=> m_isVisible(x, dlt, gd))" :key="col.key" 
								:class="col.tbClassFn?col.tbClassFn(dlt.ref) : col.tbClass||null" 
								:title="col.title"
							)
								div(v-if="col.icon||col.iconFn")
									fa-icon(:icon="col.icon||col.iconFn(dlt.ref)")
								span(:value="col.key == 'priority'? dlt.ref.priority : null") {{d_ktt.m_valFmtTsk(col, dlt.ref, true)}}
					b-button(class="btn-add-drag-item" variant="outline-grey5" 
						@click="d_ktt.m_addTask(c_swimLnPropNm, gd.id)")
						fa-icon(icon="plus" class="mr-1")
						|Add
		//- Loading
		kt-spinner(v-if="d_ktt.d_loading" p_txt="Activities")
		//- Error
		div(v-else-if="d_ktt.d_errMessage" class="error")
			p(class="text-danger") Something went wrong ☹
			p(class="my-1 text-grey5") {{d_ktt.d_errMessage}}	
			p() Please try again or refresh your browser session.
		//- No Data
		div(v-else-if="p_data.length==0" class="nodata")
			| No {{d_ktt.c_rec_Activity.slice(0, -1) + "ies"}} found 
			| {{d_ktt.d_dataParams.search? ' matching the searched value':''}}
</template>

<script>

import draggable from 'vuedraggable';
import {refData, defaults} from "@/utils/ref-data.js";
export default {
	name: "kt-task-board",
	components: {
		draggable
	},
	created() {
		fn_prepVSwimlane(this);
	},
	data() {
		return {
			d_ktt: this.$parent,
			d_groupedData: [],
		};
	},
	props: {
		p_cols: Array,
		p_data: Array,
		p_vSwimLn: Object,
	},
	computed: {
		c_swimLnPropNm() {
			switch (this.p_vSwimLn.key) {
				case 'TS': return 'taskStatusId';
				case 'TL': return 'taskLeadId';
				case 'TT': return 'taskTypeId';
				case 'TP': return 'priority';
				default: return null;
			}
		},
		// c_isTouch() {
		// 	return this.$root.$children[0].d_isTouch;
		// }
	},
	methods: {
		m_isVisible(col, dlt, s) {
			if (!col.visible) return false;
			let val = dlt.ref[col.key];

			if (Array.isArray(val) && val.length == 0) return false;
			return (val || null) != null || val === 0;
		},
		m_changeSwimlane(e, gd) {
			if (e.added) {
				let recId = e.added.element.id;
				this.d_ktt.m_updateTaskProp(recId, this.c_swimLnPropNm, gd.id);
			}
		},
		m_onStart(e) {
			e.target.classList.add('is-dragging');

			$(e.target).closest('.board-list').siblings().each((ix, x) => {
				x.classList.add('drag-to');

				let fvp = fn_isInVP(x.firstChild, 0);
				let lvp = fn_isInVP(x.lastChild, -150);
				if (!(fvp || lvp)) {
					let t = e.target.getBoundingClientRect().top;
					x.style.paddingTop = -Math.ceil(t) + 50 + "px";

				}
			});
		},
		m_onEnd(e) {
			e.target.classList.remove('is-dragging');

			$(e.target).closest('.board-list').siblings().each((ix, x) => {
				setTimeout(() => {
					x.style.paddingTop = null;
				}, 500);

			});

			let item = e.to.children[e.newIndex];
			item.classList.add('dragged');
			setTimeout(() => {item.classList.remove('dragged');}, 600);
		}
	},
	watch: {
		p_data() {
			fn_prepVSwimlane(this);
		},
		'p_vSwimLn.key'() {
			fn_prepVSwimlane(this);
		}
	}
};

function fn_prepVSwimlane(vc) {
	vc.p_cols.filter(x => x.key != 'taskDetails').forEach(x => delete x.noToggle);

	switch (vc.p_vSwimLn.key) {
		case 'TS': fn_prepByStatus(vc); break;
		case 'TL': fn_prepByLead(vc); break;
		case 'TT': fn_prepByType(vc); break;
		case 'TP': fn_prepByPriority(vc); break;
	}
}

function fn_isInVP(elem, hbuff) {
	let b = elem.getBoundingClientRect();
	let h = elem.offsetHeight + hbuff;
	let w = elem.offsetWidth;
	if (b.top >= -h
		&& b.left >= -w
		&& b.right <= (window.innerWidth || document.documentElement.clientWidth) + w
		&& b.bottom <= (window.innerHeight || document.documentElement.clientHeight) + h) {
		return true;
	} else {
		return false;
	}
}


// Vertical Swimlane
function fn_prepByStatus(vc) {
	fn_setColProps('taskStatusId', vc);

	let d = vc.p_data;
	let idKey = vc.d_ktt.c_rec_TaskId;
	let slItems = refData.taskStatuses.map((x) => ({id: x.id, name: x.name}));

	let dfltTSId = defaults.taskStatusId();
	slItems.forEach(sli => {
		// sli.classNm = 'ts-' + sli.name.replace(' ', '-').toLowerCase();
		let dlTasks = d.filter(x => (x.taskStatusId || dfltTSId) == sli.id)
			.map(x => ({'id': x[idKey], 'ref': x}));
		vc.$set(sli, 'dragList', dlTasks);
		if (/^(To Do|In Progress|Completed)$/.test(sli.name)) sli.visible = true;
		else {
			sli.visible = dlTasks.filter(x => x.ref.taskStatusId == sli.id).length > 0;
		}
	});
	vc.p_vSwimLn.items = slItems;
}
function fn_prepByLead(vc) {
	fn_setColProps('taskLeadId', vc);

	let idKey = vc.d_ktt.c_rec_TaskId;
	let slItems = (vc.d_ktt.d_refData.teamMemberId || []).map((x) => ({id: x.teamMemberId, name: x.teamMemberName}));
	slItems.unshift({id: '', name: 'No Activity Lead'});
	slItems.forEach(sli => {
		let dlTasks = vc.p_data.filter(x => (x.taskLeadId || '') == sli.id)
			.map(x => ({'id': x[idKey], 'ref': x}));
		vc.$set(sli, 'dragList', dlTasks);

		sli.visible = dlTasks.filter(x => (x.ref.taskLeadId || '') == sli.id).length > 0;
	});

	let team = vc.d_ktt.p_prntRecInfo.Team; //Parent Record Team (Owner/Internal Contact/Assigned TeamMembers)

	team.forEach(t => {
		if (!t) return;
		if (!slItems.filter(sli => sli.id == t.teamMemberId)[0]) {
			let sli = {id: t.teamMemberId, name: t.teamMemberName, visible: true, dragList: []};
			slItems.push(sli);
		}
	});
	fn_slItemsMinVisible(slItems);
	vc.p_vSwimLn.items = slItems;
}
function fn_prepByType(vc) {
	fn_setColProps('taskTypeId', vc);

	let d = vc.p_data;
	let idKey = vc.d_ktt.c_rec_TaskId;
	let slItems = refData.taskTypes.filter(x => !x.disabled).map((x) => ({id: x.id, name: x.name}));
	slItems.unshift({id: '', name: 'No Type'});
	slItems.forEach(sli => {
		let dlTasks = d.filter(x => (x.taskTypeId || '') == sli.id)
			.map(x => ({'id': x[idKey], 'ref': x}));
		vc.$set(sli, 'dragList', dlTasks);

		sli.visible = dlTasks.filter(x => (x.ref.taskTypeId || '') == sli.id).length > 0;
	});
	fn_slItemsMinVisible(slItems);
	vc.p_vSwimLn.items = slItems;
}
function fn_prepByPriority(vc) {
	fn_setColProps('priority', vc);

	let d = vc.p_data;
	let idKey = vc.d_ktt.c_rec_TaskId;
	let slItems = refData.taskPriorities.map((x) => ({id: x.value, name: x.text}));
	slItems.unshift({id: '', name: 'No Priority'});
	slItems.forEach(sli => {
		let dlTasks = d.filter(x => (x.priority || '') == sli.id)
			.map(x => ({'id': x[idKey], 'ref': x}));
		vc.$set(sli, 'dragList', dlTasks);

		sli.visible = dlTasks.filter(x => (x.ref.priority || '') == sli.id).length > 0;
	});
	fn_slItemsMinVisible(slItems);
	vc.p_vSwimLn.items = slItems;
}

// Col Props
function fn_setColProps(key, vc) {
	let col = vc.p_cols.filter(x => x.key == key)[0];
	if (!col) return;

	col.noToggle = true;
	col.default = false;
	col.visible = false;
}


function fn_slItemsMinVisible(slItems) {
	let sliV = slItems.filter(sli => sli.visible).length;
	if (sliV <= 2) {
		let sliNV = slItems.filter(sli => !sli.visible);
		sliNV.forEach((sli, ix) => {
			if (ix + sliV <= 3) sli.visible = true;
		});
	}

}

</script>

<style lang="less">
.kt-task-board {
	font-size: 0.8em;
	overflow-x: auto;
	min-height: calc(100vh - 280px);

	.board-list {
		position: relative;
		flex: 0 1 100%;
		margin: 0 0.3rem;
		> label {
			padding: 0.2em 1em;
			border: solid 0.1em #ced4da;
			border-radius: 0.3em;
			background-color: #f8f9fa;
		}
		.drag-items {
			position: relative;
			border: solid 0.1em #ced4da;
			border-radius: 0.2em;
			min-width: 10em;
			min-height: 10em;
			background-color: #f8f9fa;
			padding: 0 0.2rem;
			padding-bottom: 3em;

			// &::after {
			// 	position: absolute;
			// 	bottom: 0;
			// 	width: 100%;
			// 	display: block;
			// 	padding: 1em 0;
			// 	color: #adb5bd;
			// 	content: "Drag Items Here";
			// }

			.drag-item {
				position: relative;
				border: solid 0.1em #ced4da;
				box-shadow: 0em 0.05em 0.1em 0.15em #e9ecef;
				border-radius: 0.2em;
				background-color: #fff;
				text-align: left;
				min-height: 5em;
				padding: 0.5rem 0.3rem;
				margin: 1em 0.5em;

				&.kt-saved {
					background-color: #e0f0ff;
					border-color: #adb5bd;
					box-shadow: 0em 0.05em 0.1em 0.1em #8fc4fd;
				}
				&.dragged,
				&.sortable-chosen {
					border-color: #adb5bd;
					box-shadow: 0em 0.05em 0.1em 0.1em #8fc4fd;
					background-color: #e0f0ff;
				}
				> span.saved-check {
					position: absolute;
					top: 0.3em;
					right: 0.5em;
				}

				> div.dropdown.drag-item-opt {
					position: absolute;
					top: 0.3em;
					right: 0.5em;
					z-index: 99; //make it behinde side nav (mobile)

					.dropdown-toggle {
						font-size: 0.9em;
						svg {
							color: #4fa4ff;
						}
					}
					.dropdown-item {
						border-bottom: solid 0.1em #ced4da;
						padding: 0.2em 0.5em;
						width: 90px;
						cursor: pointer;
						svg {
							margin-right: 0.4em;
							color: #6c757d;
						}
					}
				}

				> div:not(.dropdown) {
					padding: 0.2em 0.2em;
					cursor: default;

					//***
					margin: auto 0;
					-ms-word-break: break-all;
					word-break: break-all;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2; /* number of lines to show */
					-webkit-box-orient: vertical;

					> div:first-child {
						display: inline-block;
						min-width: 1.5em;

						svg {
							color: #8fc4fd; //Default color, Overridden below
							// &.fa-calendar-alt[data-prefix="far"] {
							// 	color: #dc3545;
							// }
							&.fa-calendar-check,
							&.fa-check-circle {
								color: #28a745;
							}
							&.fa-exclamation-circle {
								color: #adb5bd; //To Do
							}

							&.fa-pause-circle,
							&.fa-ban {
								color: #dc3545; //Canceled, On Hold
							}
						}
					}
					// > span:last-child {
					// }

					&.past-due {
						> div svg {
							color: #dc3545;
						}
						> span:last-child::after {
							content: " (Past Due)";
							font-size: 0.85em;
							color: #dc3545;
						}
					}
					&.due-soon {
						> span:last-child::after {
							content: " (Due Soon)";
							font-size: 0.85em;
							color: #4fa4ff;
						}
					}
					&.due-today {
						> span:last-child::after {
							content: " (Due Today)";
							font-size: 0.85em;
							color: #4fa4ff;
						}
					}
					&.tb-prnt {
						font-weight: bold;
						// text-shadow: .05em .05em .1em #ced4da;
					}
					&.tb-id,
					&.tb-dtm,
					&.tb-usr {
						font-size: 0.85em;
						opacity: 0.6;
						> div svg {
							color: unset; //Override
						}
					}
					&.tb-dtm span {
						font-stretch: condensed;
					}
				}
			}

			&:not(.is-dragging) .drag-item:hover {
				border-color: #adb5bd;
				box-shadow: 0em 0.05em 0.1em 0.1em #8fc4fd;
			}
		}
		// &.ts-completed {
		// 	label {
		// 		font-weight: bolder;
		// 		background-color: #28a74628;
		// 	}
		// }
		.btn-add-drag-item {
			font-size: 0.9em;
			padding: 0.1em 0.5em;
			margin-top: 0.5em;
			background-color: #fff;
		}

		// border: solid 0.1em blue;
	}

	@media (max-width: 576px) {
		.board-list {
			margin: 0 0.2rem;
			.drag-items {
				padding: 0 0.1rem;
				padding-bottom: 3em;
				font-size: 0.8em;
			}
		}
	}
}
</style>